import { render } from "./TabAccountCreditCard.vue?vue&type=template&id=1985ef52"
import script from "./TabAccountCreditCard.vue?vue&type=script&lang=js"
export * from "./TabAccountCreditCard.vue?vue&type=script&lang=js"

import "./TabAccountCreditCard.vue?vue&type=style&index=0&id=1985ef52&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__